import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Seo from "../seo/Seo";
import { pageMetadata } from "../seo/metadata";

export default function NotFound() {
	return (
		<>
			<Seo metadata={pageMetadata.notFound} />
			<Navbar />
			<main id="main-content" className="min-h-screen pt-28 md:pt-36 pb-24 container mx-auto px-4 sm:px-6">
				<p className="font-display uppercase mb-4">404</p>
				<h1 className="font-display font-bold uppercase mb-6" style={{ fontSize: "var(--text-display-s)" }}>Page not found</h1>
				<p className="mb-8">This page is unavailable. Find your way back to the court.</p>
				<div className="flex flex-wrap gap-4">
					<Link to="/" className="btn-slab btn-slab--fill">Racketly home</Link>
					<Link to="/blog" className="btn-slab btn-slab--outline">Tennis & padel guides</Link>
					<Link to="/download" className="btn-slab btn-slab--outline">Download Racketly</Link>
				</div>
			</main>
		</>
	);
}
